/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import i18n from "i18next";
import {Button} from "reactstrap";
import isTime2Click from "../../utils/isTime2Click";
import {toast} from 'react-toastify';

class HearReplyCreate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            replyCount: 0,
            replyIndex: props['replyIndex'],
        };

    };

    handleClick() {
        if (!isTime2Click('HearReplyCreate')) {
            return;
        }

        const {hearReplies} = this.props;

        let repliesData = hearReplies.state.repliesData;

        let len = repliesData.length;
        repliesData[len] = {type: "text", text: "hi"};


        //TODO: show loading animation
        toast.info(i18n.t("Adding..."),{autoClose: 1500});

        hearReplies.setState({repliesData: repliesData});
        hearReplies.addReply(repliesData);
        // hearReplies.setTimeToUpdate(repliesData);
    }

    render() {
        return (
            <span>
                &nbsp; &nbsp;<Button
                    className={"ApiButton"}
                    id={this.props.id}
                    color="secondary"
                    size="sm"
                    onClick={(e) => this.handleClick(e)}
                >
                    {i18n.t("Add Reply")}
                </Button>
            </span>
        );
    }
}


export default HearReplyCreate;

